import { createSelector } from 'reselect';

import { applicationStates } from '/business/shared/util/Statics';

import getApplicationStatusSelector from './getApplicationStatusSelector';

export default createSelector(
  [getApplicationStatusSelector],
  (applicationState) => applicationState === applicationStates.CONFIRMED,
);
